// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","link":"Link_link__1X5sb","primary":"Link_primary__WRs7Z"};